import { useMetricTracking } from '@backoffice-frontend/tracking'
import { useEffect } from 'react'
import {
  setWebSocketEventListener,
  type WebSocketEvent,
} from './AuthenticatedAppView/apolloClient'

export const useWebSocketMetrics = () => {
  const { trackMetric } = useMetricTracking()

  useEffect(() => {
    setWebSocketEventListener((event: WebSocketEvent) => {
      trackMetric({
        metricName: `websocket_${event.type}`,
        value: 1,
      })
    })

    return () => {
      setWebSocketEventListener(undefined)
    }
  }, [trackMetric])
}
